"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMapStateProvider = exports.useMapState = exports["default"] = exports.MapStateContext = void 0;
var _react = require("react");
var _mapStateReducer = require("./mapStateReducer");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MapStateContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.MapStateContext = MapStateContext;
var useMapStateProvider = function useMapStateProvider() {
  var _useReducer = (0, _react.useReducer)(_mapStateReducer.mapStateReducer, _mapStateReducer.INITIAL_MAP_STATE),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    mapState = _useReducer2[0],
    dispatch = _useReducer2[1];
  return {
    MapStateContext: MapStateContext,
    mapState: mapState,
    resetMapState: function resetMapState() {
      return dispatch({
        type: 'RESET_MAP_STATE'
      });
    },
    unselect: function unselect() {
      return dispatch({
        type: 'UNSELECT'
      });
    },
    newSetSelected: function newSetSelected(nextSelected) {
      return dispatch({
        type: 'SET_SELECTED',
        payload: {
          nextSelected: nextSelected
        }
      });
    },
    newSetHovered: function newSetHovered(nextHovered) {
      return dispatch({
        type: 'SET_HOVERED',
        payload: {
          nextHovered: nextHovered
        }
      });
    },
    setAuthToken: function setAuthToken(authToken) {
      return dispatch({
        type: 'SET_AUTH_TOKEN',
        payload: {
          authToken: authToken
        }
      });
    },
    setMapAuthToken: function setMapAuthToken(mapAuthToken) {
      return dispatch({
        type: 'SET_MAP_LAYER_AUTH_TOKEN',
        payload: {
          mapAuthToken: mapAuthToken
        }
      });
    },
    setCanTag: function setCanTag(canTag) {
      return dispatch({
        type: 'SET_CAN_TAG',
        payload: {
          canTag: canTag
        }
      });
    },
    showScrubber: function showScrubber() {
      return dispatch({
        type: 'SHOW_SCRUBBER'
      });
    },
    hideScrubber: function hideScrubber() {
      return dispatch({
        type: 'HIDE_SCRUBBER'
      });
    },
    startPlayback: function startPlayback() {
      return dispatch({
        type: 'START_PLAYBACK'
      });
    },
    stopPlayback: function stopPlayback() {
      return dispatch({
        type: 'STOP_PLAYBACK'
      });
    },
    setPlaybackRange: function setPlaybackRange(from, to) {
      return dispatch({
        type: 'SET_PLAYBACK_RANGE',
        payload: {
          from: from,
          to: to
        }
      });
    },
    setTimestamp: function setTimestamp(timestamp) {
      return dispatch({
        type: 'SET_TIMESTAMP',
        payload: {
          timestamp: timestamp
        }
      });
    },
    resetPlayback: function resetPlayback() {
      return dispatch({
        type: 'RESET_PLAYBACK'
      });
    },
    setTrains: function setTrains(trains) {
      return dispatch({
        type: 'SET_TRAINS',
        payload: {
          trains: trains
        }
      });
    }
  };
};
exports.useMapStateProvider = useMapStateProvider;
var useMapState = function useMapState() {
  var _useContext = (0, _react.useContext)(MapStateContext),
    mapState = _useContext.mapState,
    resetMapState = _useContext.resetMapState,
    unselect = _useContext.unselect,
    newSetSelected = _useContext.newSetSelected,
    newSetHovered = _useContext.newSetHovered,
    setAuthToken = _useContext.setAuthToken,
    setMapAuthToken = _useContext.setMapAuthToken,
    setCanTag = _useContext.setCanTag,
    showScrubber = _useContext.showScrubber,
    hideScrubber = _useContext.hideScrubber,
    startPlayback = _useContext.startPlayback,
    stopPlayback = _useContext.stopPlayback,
    setPlaybackRange = _useContext.setPlaybackRange,
    setTimestamp = _useContext.setTimestamp,
    resetPlayback = _useContext.resetPlayback,
    setTrains = _useContext.setTrains;
  return {
    mapState: mapState,
    resetMapState: resetMapState,
    unselect: unselect,
    newSetSelected: newSetSelected,
    newSetHovered: newSetHovered,
    setAuthToken: setAuthToken,
    setMapAuthToken: setMapAuthToken,
    setCanTag: setCanTag,
    showScrubber: showScrubber,
    hideScrubber: hideScrubber,
    startPlayback: startPlayback,
    stopPlayback: stopPlayback,
    setPlaybackRange: setPlaybackRange,
    setTimestamp: setTimestamp,
    resetPlayback: resetPlayback,
    setTrains: setTrains
  };
};
exports.useMapState = useMapState;
var _default = useMapState;
exports["default"] = _default;